<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import {
  Pivot,
  ReportDesign,
} from "../../../types/report";
//import AddField from "./AddField.vue";
//import IconComponent from "../../ui/common/IconComponent.vue";
//import Buttons from "../../ui/form/Buttons.vue";
//import SearchSelect from "../../ui/form/SearchSelect.vue";
import { useFormValidation } from "../../../composables/useFormValidation";
import { required } from "../../../utils/validation";
import Toast from "../../../services/Toast";
import { api } from "../../../api/Api";
import { formatNumber, isEmpty, isNumeric } from "../../../utils/CommonFunctions";
import Buttons from "../../ui/form/Buttons.vue";
import ReportFilter from "../ReportFilter.vue";
//import NumberInput from "../../ui/form/NumberInput.vue";
//import CheckInput from "../../ui/form/CheckInput.vue";
//import RadioInput from "../../ui/form/RadioInput.vue";
//import { mapSqlTypeToVueType } from "../../../types/mapSqlTypeToVueType";
//import { api } from "../../../api/Api";
//import Toast from "../../../services/Toast";
//import RadioCheckInput from "../../ui/form/RadioCheckInput.vue";

const props = defineProps<{
  report: ReportDesign;
  data?: any;
  mode?: "create" | "edit" | "view" | "showQuickView" | "toggleStatus";
}>();

/*const emit = defineEmits<{
  (e: "addField", data: Field): void;
}>();*/

//const expandedTables = ref<string[]>([]);
/*const showFieldProperties = ref(false);
const selectedField = ref<Field>();
const fieldToAdd = ref<Field>();

/*const toggleTable = (tableKey: string) => {
  const index = expandedTables.value.indexOf(tableKey);
  if (index === -1) {
    expandedTables.value.push(tableKey);
  } else {
    expandedTables.value.splice(index, 1);
  }
};

const isTableExpanded = (tableKey: string) => {
  return expandedTables.value.includes(tableKey);
};

const selectField = (field: any) => {
  emit("addField", field);
};*/

const {
  fields,
  //formData,
  setFieldRules,
  //validateForm,
  //resetForm,
  //setFormData,
} = useFormValidation({
  pivotFieldId: props.data?.pivotFieldId || null,
  aggregateFieldId: props.data?.aggregateFieldId || null,
  aggregateFunction: props.data?.aggregateFunction || undefined,
  fields: props.data?.fields || [],
  dynamicFields: props.data?.dynamicFields || false,
  dbTable: props.data?.dbTable || "",
  dbField: props.data?.dbField || "",
  sortField: props.data?.sortField || "",
  width: props.data?.width || 100,
  sortOrder: props.data?.sortOrder || "asc",
});

setFieldRules("pivotFieldId", [required("Pivot Field is required")]);
setFieldRules("aggregateFieldId", [required("Aggregate Field is required")]);
setFieldRules("aggregateFunction", [
  required("Aggregate Function is required"),
]);
setFieldRules("fields", [required("Select at least one field")]);

setFieldRules(
  "dbTable",
  fields.value.dynamicFields.value
    ? [required("Select Table for Dynamic fields")]
    : []
);
setFieldRules(
  "dbField",
  fields.value.dynamicFields.value
    ? [required("Select Display Field for Dynamic Fields")]
    : []
);
setFieldRules(
  "sortField",
  fields.value.dynamicFields.value
    ? [required("Select Sort field for Dynamic Fields")]
    : []
);
setFieldRules(
  "sortOrder",
  fields.value.dynamicFields.value
    ? [required("Select Sort Order for Dynamic Fields")]
    : []
);

/*const addFieldToReport = (field: Field) => {
  field.manual = true;
  emit("addField", field);
  showFieldProperties.value = false;
};*/

/*const addFieldToReport = () => {
  if (props.report && selectedField.value) {
    props.report.pivot?.fields.push({
      tableField: selectedField.value.tableField,
      alias: selectedField.value.alias,
      caption: selectedField.value.caption,
      visible: selectedField.value.visible,
      align: selectedField.value.align
    })
    showFieldProperties.value = false
    selectedField.value = null
  }
}

const removeField = (index: number) => {
  if (props.report.value) {
    props.report.value.fields.splice(index, 1)
  }
}*/

/*const moveFieldUp = (index: number) => {
  if (index > 0) {
    const field = props.report.pivot?.fields[index];
    if (field) {
      props.report.pivot?.fields.splice(index, 1);
      props.report.pivot?.fields.splice(index - 1, 0, field);
      props.report.pivot?.fields.forEach((f, i) => {
        f.sort_order = i;
      });
    }
  }
};

const moveFieldDown = (index: number) => {
  if (
    props.report.pivot?.fields &&
    index < props.report.pivot.fields.length - 1
  ) {
    const field = props.report.pivot.fields[index];
    props.report.pivot.fields.splice(index, 1);
    props.report.pivot.fields.splice(index + 1, 0, field);
    props.report.pivot.fields.forEach((f, i) => {
      f.sort_order = i;
    });
  }
};

const removeField = (index: number) => {
  if (
    props.report.fields &&
    props.report.pivot?.fields &&
    index >= 0 &&
    index < props.report.pivot.fields.length
  ) {
    props.report.pivot.fields.splice(index, 1);
    props.report.pivot.fields.forEach((f, i) => {
      f.sort_order = i;
    });
  }
};

const dragStart = (index: number) => {
  draggingIndex.value = index;
};
const draggingIndex = ref<number | null>(null);
const dragOver = (index: number) => {
  if (draggingIndex.value !== null && draggingIndex.value !== index) {
    const field = props.report.pivot?.fields[draggingIndex.value];
    if (field) {
      props.report.pivot?.fields.splice(draggingIndex.value, 1);
      props.report.pivot?.fields.splice(index, 0, field);
      draggingIndex.value = index;
      props.report.pivot?.fields.forEach((f, i) => {
        f.sort_order = i;
      });
    }
  }
};*/

/*const drop = (_index: number) => {
  draggingIndex.value = null;
};*/

onMounted(() => {
  console.log("StepField component mounted");
  console.log(props.report);
});

//const tableFields = ref<Field[]>([]);

/*const getFields = async (table: Table) => {
  try {
    const response = await api.post("/clients/reports/fields", {
      table: table.id,
    });
    if (response.success == true) {
      let data = response.data;
      data.forEach((field: { field_type: string }) => {
        field.field_type = mapSqlTypeToVueType(field.field_type);
      });
      tableFields.value = data;
    }
  } catch (error) {
    Toast.show(String(error) || "Failed to fetch Source Fields", "error");
    return [];
  }
};*/

/*const availableFields = computed(() =>
  props.report.pivot?.fields.filter(
    (field) => !props.report.pivot?.fields.some((f) => f === field)
  )
);*/

  const getDataFromTable = async (pivot: Pivot): Promise<any[]> => {
    try {
      const response = await api.post("/clients/reports/data", {
        table: pivot.dbTable,
        field: pivot.dbField,
        sortField: pivot.sortField,
        sortOrder: pivot.sortOrder,
      });
      if (response.success == true) {
        return response.data;
      }
      return [];
    } catch (error) {
      Toast.show(String(error) || "Failed to fetch Source Fields", "error");
      return [];
    }
  };

const sqlQuery = ref('')
const prePareSqlQuery = async () => {
  if (!props.report || !props.report.fields) return "";
  let iSql = " SELECT ";
  iSql += props.report.fields.filter((e) => e.raw == false)
    .map((field) => (field.aggregateFunction ? `${field.aggregateFunction}([${field.tableAlias}].[${field.name}])` : `[${field.tableAlias}].[${field.name}]`) + `AS [${field.caption}]`)
    .join(", ");

  let rawFields = props.report.fields.filter((e) => e.raw == true);
  if (rawFields.length > 0) {
    if (iSql.length > 0) iSql += ", ";
    iSql += props.report.fields.filter((e) => e.raw == true)
      .map((field) => field.rawQuery + ` AS [${field.caption}]`)
      .join(", ");
  }
  
  iSql += ` FROM ${props.report.baseTable} as ${props.report.baseTableAlias}`;
  let doGroup = props.report.fields.filter((e) => !isEmpty(e.aggregateFunction)).length > 0
  if (doGroup) {
    iSql += ' GROUP BY ' + props.report.fields.filter((e) => isEmpty(e.aggregateFunction))
    .map((field) => `[${field.tableAlias}].[${field.name}]`)
    .join(", ");
  }


  if (props.report.tables && props.report.tables.length > 0) {
    props.report.tables.forEach((table) => {
      if (!table.baseTable) {
        if (table.raw) {
          iSql += ` ${table.joinType} (${table.rawQuery}) AS ${table.alias} ON ${table.alias}.${table.sourceField} = ${table.targetTableAlias}.${table.targetField}`;
        } else {
          iSql += ` ${table.joinType} ${table.name} AS ${table.alias} ON ${table.alias}.${table.sourceField} = ${table.targetTableAlias}.${table.targetField}`;
          const conditions = (table.conditions ?? []).filter((cond: any) =>
            cond.tableAlias && cond.fieldName && cond.operator && cond.value !== undefined && cond.value !== null
          );
          if (conditions.length > 0) {
            iSql += (conditions.length > 1 ? " AND " : " WHERE ");
            iSql += conditions
              .map(
                (cond: any) =>
            `${cond.tableAlias}.${cond.fieldName} ${cond.operator} '${cond.value}'`
              )
              .join(" AND ");
          }
        }
      }
    });
  }

  if (props.report.filters.length > 0) {
    iSql += " WHERE ";
    iSql += props.report.filters
      .map((filter) => {
        let condition = "";
        if (filter.group) {
          condition = filter.childFilters
            ? `(${filter.childFilters.map((f) => f.condition).join(` ${filter.condition} `)})`
            : "";
        } else if (filter.raw) {
          condition = `${filter.rawQuery} ${filter.operator} '${filter.value}'`;
        }
        return condition;
      })
      .join(" AND ");
  }
  
  let sql = '';
  if (props.report.pivot && props.report.pivot?.fields && props.report.pivot.fields.length > 0) {
    
    var dynamicFieldData = [];
    if (props.report.pivot.dynamicFields) {
      let pivot: Pivot = props.report.pivot;
      if (pivot.dbTable && pivot.dbField && pivot.sortField && pivot.sortOrder) {
        dynamicFieldData = await getDataFromTable(pivot);
      } 
    }

    sql = "SELECT " + props.report.pivot.fields
      .map((field) => `[${field.caption}]`)
      .join(", ");

    if (dynamicFieldData && dynamicFieldData.length > 0) {
      const dbFieldKey = props.report?.pivot?.dbField;
      if (dbFieldKey) {
        sql += ", " + dynamicFieldData.map((item) => `[${item[dbFieldKey]}]`).join(", ");
      }
    }

    sql += ` FROM (${iSql}) t`;

    sql += " PIVOT (";    
    sql += ` ${props.report.pivot.aggregateFunction} ([${props.report.pivot.aggregateFieldId}]) FOR [${props.report.pivot.pivotFieldId}] IN (`;
    const pivotted = props.report.pivot.fields.filter((field) => field.manual == true)
      .map((field) => `[${field.alias}]`)
      .join(", ");
      
    if (dynamicFieldData && dynamicFieldData.length > 0) {
      const dbFieldKey = props.report?.pivot?.dbField;
      if (dbFieldKey) {
        sql += pivotted + (pivotted.length > 0 ? ", " : '') + dynamicFieldData.map((item) => `[${item[dbFieldKey]}]`).join(", ");
      }
    }

    sql += `)) AS p`;

  } else {
    sql = "SELECT " + props.report.fields
    .map((field) => `[${field.caption}]`)
    .join(", ");
  sql += ` FROM (${iSql}) t`;
  }
  
  sqlQuery.value = sql;
};

const sampleData = ref<any[]>([]);
const columns = ref<{ field: string; header: string }[]>([]);

const getReport = async () => {
  console.log("Fetching sample data for report:", props.report);
  if (props.report.rawReport && isEmpty(props.report.rawQuery))
    return;
  const response = await api.post("clients/reports/sample-data", {
    report: JSON.stringify(props.report),
  });
  if (response.success == true) {
    sampleData.value = response.data.slice(0, 10);
    if (sampleData.value && sampleData.value.length > 0) {
      columns.value = Object.keys(sampleData.value[0])
      .filter((key) => key !== "hasChild") // Exclude hasChild from display
      .map((field) => ({
        field,
        header:
          field.charAt(0).toUpperCase() +
          field
            .slice(1)
            .replace(/([A-Z])/g, " $1")
            .trim()
            .replace("_", " "), // Convert camelCase to Title Case
      }));
    }
  }
};

watch(
  () => JSON.stringify(props.report),
  () => {
    console.log("Report updated:", props.report);
    prePareSqlQuery();
    getReport();
  },
  { immediate: true }
);

const isNumericColumn = (field: any) => {
  if (field.toLowerCase().includes("date") || field.toLowerCase().includes("time") || field.toLowerCase().includes("code") || field.toLowerCase() == 'cost') {
    return false; // Exclude date/time fields from numeric check
  }
  return sampleData.value.some((row) => isNumeric(row[field]));
};

const getColumnTotal = (field: any) => {
  return sampleData.value.reduce((sum, row) => {
    return sum + (isNumeric(row[field]) ? parseFloat(row[field]) : 0);
  }, 0);
};


const showFilterScreen = ref(false);
const testFilter = () => {
  showFilterScreen.value = true;
}

const filterReport = () => {
  console.log("Filter Report with filters:", props.report.filters);
  // Emit an event to open the filter screen
  showFilterScreen.value = false;
};

</script>

<template>
  <div class="fields-section section">
    <div
      class="section-header"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <div id="step-name" style="display: flex; align-items: center">
        <div class="step-indicator">Step 6</div>
        <h2 style="margin-left: 0.75rem">Query Preview</h2>
      </div>
    </div>

    <div class="preview-container" v-if="!report.rawReport">
      <div class="available-fields">
        <h3>SQL Query</h3>
        <div class="field-tree">
          <div class="field-list">
            <div v-if="report.fields.length === 0" class="empty-state">
              <p>No fields selected.</p>
            </div>
            <div>
              {{sqlQuery}}
              </div>
          </div>

          <div></div>
        </div>
      </div>
      <div></div>
    </div>

    <div class="preview-container">
      <div class="available-fields">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <h3 style="margin: 0;">Sample Data</h3>
          <div id="add-raw-field">
        <Buttons
          caption="Test Filter"
          v-if="props.report?.filters.length > 0"
          type="info"
          icon="Plus" 
          @click="testFilter"
        />
        </div>
      </div>
        <div class="field-tree mt-2">
          <div class="field-list">
            <div v-if="sampleData.length === 0" class="empty-state">
              <p>No Data.</p>
            </div>
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th v-for="column in columns" :key="column.field">
                      {{ column.header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in sampleData"
                    :key="row.id"
                    :class="{ expandable: row.hasChild }"
                  >
                    <template v-for="column in columns" :key="column.field">
                      <td class="text-right" v-if="isNumeric(row[column.field])">
                        {{ formatNumber(row[column.field]) }}
                      </td>
                      <td v-else>
                        {{ row[column.field] }}
                      </td>
                    </template>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <template v-for="column in columns" :key="column.field">
                      <td class="text-right" v-if="isNumericColumn(column.field)">
                        <strong>{{
                          formatNumber(getColumnTotal(column.field))
                        }}</strong>
                      </td>
                      <td v-else></td>
                    </template>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div></div>
        </div>
      </div>
      <div></div>
    </div>
    <ReportFilter 
    v-if="showFilterScreen"
    :filters="props.report.filters"
    title="Report Filters"
    @close="showFilterScreen = false"
    @filter="filterReport"
    />
  </div>
</template>
<style scoped>
.preview-container {
  display: grid;
  gap: 2rem;
}

.available-fields,
.selected-fields {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 1rem;
}

.available-fields h3,
.selected-fields h3 {
  font-size: 1rem;
  margin: 0 0 1rem 0;
  color: #495057;
}

.field-tree {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.table-node {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: white;
  cursor: pointer;
  user-select: none;
}

.table-header:hover {
  background-color: #f8f9fa;
}

.field-list {
  padding: 0.5rem;
  margin-left: 1.2rem;
  background-color: white;
}

.field-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 4px;
}

.field-item:hover {
  background-color: #f8f9fa;
}

.field-item i {
  color: #6c757d;
  font-size: 0.875rem;
}

.empty-state {
  text-align: center;
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  color: #6c757d;
}



.table-container {
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
  padding: 0 1rem;
}

thead,
tfoot {
  position: sticky;
  width: fit-content;
  background: white;
  z-index: 10;
}

thead {
  top: 0;
}

tfoot {
  bottom: 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  color: #333;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
  position: sticky;
  top: 0;
  z-index: 1;
}


</style>
